import React, { useEffect, useState } from 'react'
import CardLoader from 'components/organisms/card-loader'
import {
  CmsLuxurySectionCarouselBanners,
  CmsLuxurySectionSubBanners
} from 'domains/cms-luxury-section/organisms'
import CmsLuxurySectionsApiV2 from 'api/v2/admins/cms/luxury/cms-luxury-sections-api-v2.js'
import PropTypes from 'prop-types'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const Placeholder = ({ title, size, backgroundColor, fontColor = '#32325d' }) => (
  <div
    className='d-flex align-content-center justify-content-center flex-wrap pt-2'
    style={{
      backgroundColor : backgroundColor,
      height          : `${size}rem`
    }}
  >
    <h3 style={{ color: fontColor }}>{ title }</h3>
  </div>
)

const CmsLuxurySectionListPage = ({ pageUtils }) => {
  const [ banners, setBanners ]       = useState([])
  const [ subBanners, setSubBanners ] = useState([])
  const [ isLoading, setIsLoading ]   = useState(true)

  useEffect(() => {
    CmsLuxurySectionsApiV2.get()
      .then((response) => {
        const data       = response.data.sections
        const banners    = data.banners
        const subBanners = data.sub_banners

        setBanners(banners)
        setSubBanners(subBanners)
        setIsLoading(false)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }, [ pageUtils ])

  return (
    isLoading
      ? <CardLoader />
      : (
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <Placeholder
                title={ 'NAVBAR' }
                size={ 3 }
                backgroundColor={ '#ed569a' }
                fontColor={ 'white' }
              />

              <CmsLuxurySectionCarouselBanners banners={ banners } />

              <CmsLuxurySectionSubBanners subBanners={ subBanners } />

              <div className='mt-3'>
                <Placeholder
                  title={ 'PRODUCT LIST' }
                  size={ 20 }
                  backgroundColor={ '#ed569a' }
                  fontColor={ 'white' }
                />
              </div>
              <Placeholder
                title={ 'FEATURED SELLER' }
                size={ 6 }
                backgroundColor={ '#f1edea' }
              />
              <Placeholder
                title={ 'FOOTER' }
                size={ 10 }
                backgroundColor={ '#3c3c3c' }
                fontColor={ 'white' }
              />
            </div>
          </div>
        </div>
      )
  )
}

Placeholder.propTypes                 = {
  title           : PropTypes.string,
  size            : PropTypes.number,
  backgroundColor : PropTypes.string,
  fontColor       : PropTypes.string
}
CmsLuxurySectionListPage.propTypes    = propTypes
CmsLuxurySectionListPage.defaultProps = defaultProps

export default CmsLuxurySectionListPage
